<template>
  <div class="ui container">
    <form class="ui form">
      <div class="ui accordion">
        <div class="title active">
          <h3 class="ui dividing header fdinpro default-header-green">
            BLOQUE DE CÓDIGOS <i class="dropdown icon"></i>
          </h3>
        </div>
        <div class="content active field">
          <label class="fdinpro label-form">Subir Excel</label>
          <input
            type="file"
            class="filepond"
            name="filepond"
          /><!--data-allow-reorder="true" data-max-file-size="3MB" data-max-files="3"-->
          <br /><br />
          <div class="ui fluid button modal-button-green" tabindex="0">
            Enviar
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "NvidiaTicketStoreExcelUpload",
  data() {
    return {};
  },
};
</script>

<style scoped>
@import url("https://nworkforce.com/librerias/css/fonts/fonts.css");

.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.label-form {
  font-size: 0.8rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
.ui.container {
  width: auto !important;
}
</style>
